import { render, staticRenderFns } from "./opt-in-item.vue?vue&type=template&id=2a944c81&scoped=true&"
import script from "./opt-in-item.vue?vue&type=script&lang=js&"
export * from "./opt-in-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a944c81",
  null
  
)

export default component.exports